module.exports = __webpack_public_path__ + "static/media/one-upper-badge.83043367.svg";